import { render, staticRenderFns } from "./proposed-product-actions.vue?vue&type=template&id=1c063be2"
import script from "./proposed-product-actions.vue?vue&type=script&lang=js"
export * from "./proposed-product-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports